export default "__VITE_ASSET__55225335__"